import React, {FC, useEffect, useState} from "react";
import {Button, Typography} from "@mui/material";
import {SmallSizeDialogStyled} from "../manageActorsDialog/styled";
import {
    AddVariableDialogActionsStyled,
    AddVariableDialogContentStyled,
    AddVariableDialogTitleStyled
} from "../addVariableDialog/styled";
import {createEventCommonDialogOpen} from "../../../helpers";
import {TCommonDialogOpenEventData} from "../../../types";
import {commonDialogOpenEventName} from "../../../constants";
import {LoadingButton} from "../../../../Basic/CommonButtons";

interface IProps {
    onConfirm: () => void;
    isLoading: boolean;
}
export const OnInvalidateDocumentDialog: FC<IProps> = ({onConfirm, isLoading}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const type: TCommonDialogOpenEventData["type"] = "onInvalidate";
    const text = `By invalidating the document, it will return to the Draft status.`;
    const title = 'Invalidate document';

    const handleClose = () => {
        createEventCommonDialogOpen({type, isOpen: false, data: []});
    };

    const handleEvent = (ev: Event) => {
        const {detail} = ev as CustomEvent<TCommonDialogOpenEventData>;
        if (detail.type === type) {
            setIsOpen(detail.isOpen);
        }
    }

    useEffect(() => {
        document.addEventListener(commonDialogOpenEventName, handleEvent);
        return () => {
            document.removeEventListener(commonDialogOpenEventName, handleEvent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SmallSizeDialogStyled open={isOpen} onClose={handleClose}>
            <AddVariableDialogTitleStyled>
                {title}
            </AddVariableDialogTitleStyled>

            <AddVariableDialogContentStyled>
                <Typography>{text}</Typography>
            </AddVariableDialogContentStyled>

            <AddVariableDialogActionsStyled>
                <Button variant={"text"} onClick={handleClose}>{'Cancel'}</Button>
                <LoadingButton loading={isLoading} variant={"contained"} onClick={onConfirm}>{'Invalidate'}</LoadingButton>
            </AddVariableDialogActionsStyled>
        </SmallSizeDialogStyled>
    )
}
